import React from 'react';

function Footer() {
    return (
        <footer>
            <p>&copy; [2023] [Apoorv Anand]. All Rights Reserved.</p>
        </footer>
    );
}

export default Footer;
